import { AffiliationAvailabilityBoundary } from '@/hooks/use-affiliation-availability';
import { Button, HStack } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/modal/modal';
import CreateNewProgramForm from './CreateNewProgramForm';

interface CreateNewProgramModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const FORM_ID = 'new-affiliate-program-form';

const CreateNewProgramModal = ({ isOpen, onClose }: CreateNewProgramModalProps) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <AffiliationAvailabilityBoundary isOpen={isOpen} onClose={onClose}>
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        title={t('programs.modals.createProgram.title')}
        maxWidth="500px"
      >
        <CreateNewProgramForm formId={FORM_ID} onSubmitting={setIsSubmitting} onSuccess={onClose} />
        <HStack gap={3} justify="flex-end" mt={6}>
          <Button variant="outline" onClick={onClose} disabled={isSubmitting}>
            {t('common.cancel')}
          </Button>
          <Button type="submit" form={FORM_ID} loading={isSubmitting} disabled={isSubmitting}>
            {t('common.create')}
          </Button>
        </HStack>
      </Modal>
    </AffiliationAvailabilityBoundary>
  );
};

export default CreateNewProgramModal;
